import React, {useState, useRef, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {importEvent} from '../../../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import {assets} from '../../../../../../../utils/assetsSrc';
import ImportEvent from '../../../../components/import-event/importEvent';
import Confirmation from '../../../../../../../components/confirmation/confirmation';
import useConfirmationModal from '../../../../../../../hooks/useConfirmationModal';
import useAutoResizingTextarea from '../../../../../../../hooks/useAutoResizingTextArea';
import useEditSave from './hooks/useEditSave';
import { EventStatusEnum } from '../../../../../../../utils/constants';

export default function SubCategoryEvents({
  subCat,
  idx,
  handleEventSelection,
  handldeSubCatDelete,
  addNoteToEventSubCat,
  clearNoteToEventSubCat,
  readOnly,
}) {
  const [addSubNote, setAddSubNote] = useState(subCat?.note?.length > 0);
  const [subCatNote, setSubCatNote] = useState(subCat.note || '');
  const [showImportModal, setShowImportModal] = useState(false);
  const [editValueForSubCat, setEditValueForSubCat] = useState(subCat?.note);
  const dispatch = useDispatch();
  const {isEditMode, toggleMode, saveData} = useEditSave(
    subCat?.note?.length ? true : false,
  );

  const textareaRef = useRef(null);
  const {handleInputChange} = useAutoResizingTextarea(
    textareaRef,
    subCatNote,
    setSubCatNote,
  );

  const {isVisible, config, showModal, hideModal, confirmAction} =
    useConfirmationModal({
      onConfirm: subCat => {
        if (config.confirmationType === 'warning') {
          if (subCat)
            clearNoteToEventSubCat(subCat, () => {
              setAddSubNote(false);
              setSubCatNote('');
              setEditValueForSubCat('');
            });
        } else if (config.confirmationType === 'deleteSubCategory') {
          handldeSubCatDelete(subCat?.eventId, subCat?.eventSubCatId);
        }
      },
      onCancel: () => {},
    });

  const handleAddSubCatNote = () => {
    setAddSubNote(true);
  };

  const handleImportEventAction = payload => {
    dispatch(
      importEvent({
        payload,
        callback: resp => {
          setShowImportModal(false);
        },
      }),
    );
  };

  const handleDeleteNote = () => {
    const lengthOfNote = editValueForSubCat?.length;
    if (!lengthOfNote || lengthOfNote === 0) {
      setSubCatNote('');
      setAddSubNote(false);
    } else
      showModal({
        label: 'Are you sure you want to clear the note?',
        confirmationType: 'warning',
        subCat,
      });
  };

  const handleSubCateDelete = (eventId, eventSubCatId) => {
    const dataObject = {
      eventId,
      eventSubCatId,
    };
    showModal({
      label: 'Are you sure you want to delete the sub category?',
      confirmationType: 'deleteSubCategory',
      dataObject,
    });
  };

  const handleSaveClicked = async () => {
    await saveData(() => {
      addNoteToEventSubCat(subCat?.id, subCatNote);
      setEditValueForSubCat(subCatNote);
    });
  };

  const eventStatusItem = useMemo(() => {
    if (subCat?.event_status == null || subCat?.event_status === '') {
      return null;
    }
    return EventStatusEnum.find(
      item => Number(item.value) === Number(subCat.event_status),
    );
  }, [subCat?.event_status]);


  return (
    <div className={`sub-category-list-wrapper`}>
      <div className="main-row">
        <div className="row-1">
          <div className="heading">
            <span className="number">{`${
              subCat?.event_detail?.event_sequence
            }.${idx + 1}`}</span>
            <div className="name-note-container">
              <span className="name">
                {subCat?.event_sub_category_detail?.name}
              </span>
              {/* {subCat.note && <div className="note">{subCat.note}</div>} */}
            </div>
          </div>
        </div>
        <div className="more-details">

        {subCat?.action_required_by && (
                <span style={{color: 'red', fontWeight: 'bold',marginRight: '10px'}}>
                  Action required
                </span>
              )}
        {eventStatusItem && (
                <span style={{color: eventStatusItem?.color,marginRight: '10px'}}>
                  {eventStatusItem?.label}
                </span>
              )}
          {!readOnly && (
            <div
              className="copy-events"
              onClick={() => setShowImportModal(true)}>
              <img style={{marginRight: '5px'}} src={assets.copyIcon} />
              Import
            </div>
          )}
          {!readOnly && !subCatNote && (
            <div onClick={handleAddSubCatNote} style={{cursor: 'pointer'}}>
              <img style={{marginRight: '5px'}} src={assets.addFilled} />
              <span className="add-note-text">Add note</span>
            </div>
          )}
          {!readOnly && (
            <div style={{marginLeft: '15px', cursor: 'pointer'}}>
              <img
                onClick={() =>
                  handleSubCateDelete(
                    subCat?.id,
                    subCat?.event_sub_category_detail?.id,
                  )
                }
                src={assets.trash}
              />
            </div>
          )}
          <div
            style={{marginLeft: '15px', cursor: 'pointer'}}
            className="forward-arrow">
            <span className="forward-arrow" onClick={handleEventSelection}>
              <img src={assets.chevronRight} />
            </span>
          </div>
        </div>
      </div>
      {addSubNote && !readOnly && (
        <div className="note-row">
          <label htmlFor="note-input">Note (optional)</label>
          <textarea
            id="note-input"
            ref={textareaRef}
            value={subCatNote}
            disabled={isEditMode}
            onChange={handleInputChange}
            rows="1"
            style={{
              overflow: 'hidden',
              resize: 'none',
              width: '100%',
              minHeight: '3em',
            }}
          />

          <span className="items-container-events-category">
            {isEditMode ? (
              <span
                className="edit"
                onClick={e => {
                  e.stopPropagation();
                  toggleMode();
                }}>
                <img
                  src={assets.editIcon2}
                  style={{
                    cursor: 'pointer',
                    scaale: '1.2',
                    marginLeft: '5px',
                  }}
                  alt="edit"
                />
              </span>
            ) : (
              <>
                <img
                  onClick={() =>
                    editValueForSubCat?.length > 0 || subCatNote?.length > 0
                      ? handleSaveClicked()
                      : undefined
                  }
                  style={{
                    scale: '1.2',
                    margin: '10px',
                    cursor:
                      editValueForSubCat?.length > 0 || subCatNote?.length > 0
                        ? 'pointer'
                        : 'default',
                    opacity:
                      editValueForSubCat?.length > 0 || subCatNote?.length > 0
                        ? 1
                        : 0.5,
                  }}
                  src={assets.checkIcon}
                  alt="Add Note"
                />
                <img
                  onClick={() => handleDeleteNote()}
                  style={{
                    transform: 'scale(1.2)',
                    margin: '10px',
                    cursor: 'pointer',
                  }}
                  src={assets.closeIcon}
                  alt="Clear Note"
                />
              </>
            )}
          </span>
        </div>
      )}

      {showImportModal && (
        <ImportEvent
          label={'Import'}
          show={showImportModal}
          setShow={setShowImportModal}
          data={subCat}
          handleImportEventAction={handleImportEventAction}
        />
      )}

      <Confirmation
        label={config.label}
        show={isVisible}
        setShow={hideModal}
        confirmationType={'typeDelete'}
        secondaryButtonClickHandler={hideModal}
        primaryButtonClickHandler={() => confirmAction(config.dynamicData)}
      />
    </div>
  );
}
